import React from "react";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <span className="relative inline-flex h-8 w-8 items-center justify-center">
      <svg viewBox="0 0 40 40" className="h-8 w-8" fill="none" aria-hidden>
        <defs>
          <linearGradient id="lg" x1="0" y1="0" x2="40" y2="40">
            <stop offset="0%" stopColor="#FDE68A" />
            <stop offset="55%" stopColor="#D4AF37" />
            <stop offset="100%" stopColor="#B87333" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="36" height="36" rx="9"
              stroke="url(#lg)" strokeWidth="1.6" fill="rgba(212,175,55,0.06)" />
        <path d="M12 26 L20 12 L28 26 M15.2 21 H24.8" stroke="url(#lg)" strokeWidth="1.8"
              strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
    <span className="font-serif text-lg md:text-xl font-medium tracking-tight text-white">
      AIBoxHub
    </span>
  </div>
);

export default Logo;
